import { useSignInModal } from "../context/SignInModalContext";
import SignInModal from "./SignInModal";
import { useAuth } from "../context/AuthContext";

export function GlobalSignInModal() {
  const { isVisible, closeSignInModal } = useSignInModal();
  const { isAuthenticated } = useAuth();

  return (
    <SignInModal
      isVisible={isVisible && !isAuthenticated}
      onClose={closeSignInModal}
      onSignInSuccess={closeSignInModal}
    />
  );
}
